// extracted by mini-css-extract-plugin
export default {"wrapper":"_2aD8S"};